export default (label) => {
  switch (label) {
    case 'EQUIPMENT':
      return ({ primaryEquipment, route: { key } }) => {
        if (primaryEquipment) {
          return primaryEquipment.key;
        }
        return key;
      };
    case 'DRIVER':
      return ({ primaryDriver, route: { key } }) => {
        if (primaryDriver) {
          return `${primaryDriver.key} - ${primaryDriver.name}`;
        }
        return key;
      };
    case 'DRIVER_NAME':
      return ({ primaryDriver, route: { key } }) => {
        if (primaryDriver) {
          return primaryDriver.name;
        }
        return key;
      };
    case 'DRIVER_KEY':
      return ({ primaryDriver, route: { key } }) => {
        if (primaryDriver) {
          return primaryDriver.key;
        }
        return key;
      };
    case 'ROUTE_DRIVER_NAME':
      return ({ route: { key }, primaryDriver }) => {
        const name = (primaryDriver) ? ` - ${primaryDriver.name}` : '';
        return `${key}${name}`;
      };
    case 'ROUTE':
    default:
      return ({ route: { key } }) => key;
  }
};
